var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"bannerImg"},[_c('img',{attrs:{"src":_vm.bannerImg,"alt":""}})]),_c('div',{staticClass:"banner_text"},[_c('div',{staticClass:"wenzi"},[_c('img',{attrs:{"src":_vm.wenziImg}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }